// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

import { useKioskJaneModeContext } from '../../providers';

export const ThemedBackground = styled.div(({ style, theme }) => {
  const isJaneMode = useKioskJaneModeContext();

  return {
    backgroundColor: isJaneMode
      ? theme.colors.grays.ultralight
      : theme.colors.primary.main,
    ...style,
  };
});
